import { useQuery } from "@tanstack/react-query";
import { CguApiClient } from "../api-client/api-client";
import type { CguType } from "../types";
export const useCguListDataQuery = () =>
  useQuery<CguType[], Error, CguType[]>({
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryKey: ["cguList"],
    queryFn: async () => await CguApiClient.getCguList()
  });
